/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Treadmill/millWheel.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation16.play();
    actions.Animation16.repetitions = 1;
    actions.Animation16.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="wheel" geometry={nodes.wheel.geometry} material={materials.Material} />
      </group>
    </group>
  )
}

useGLTF.preload('/Treadmill/millWheel.glb')
